import { GetCascadeReportGraphResponse } from "api/TenantSlug/Report/api.ts";

type KeysUnion = keyof GetCascadeReportGraphResponse["timeline"][number][number];

export const ALLOWED_KEYS: KeysUnion[] = [
    "total",
    "accepted",
    "filtered",
    "refused_check",
    "error_check",
    "checked",
    "error_send",
    "refused_send",
    "send",
    "redirected",
    "rejected",
    "epl",
    "revenue",
];

export type AllowedKeys = (typeof ALLOWED_KEYS)[number];

export const DEFAULT_VISIBLE_KEYS: AllowedKeys[] = [
    "total",
    "filtered",
    "error_check",
    "refused_check",
    "error_send",
    "refused_send",
    "accepted",
];
